// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"477":"06179586","573":"d0076362"}[chunkId] + ".chunk.css";
};